<template lang="pug">
.filters(aria-label="Listing filters")
	.filters-row
		.filters-column(v-if="terms.Type == 'select'")
			app-select(:data="terms", :terms="true")
		.filters-column(v-for="(filter, i) in data" v-if="i < count")
			app-select(v-if="filter.Type=='select'", :data="filter")
			app-multi-select(v-if="filter.Type=='multiselect'", :data="filter")
			app-range(v-if="filter.Type=='range'", :data="filter")

	.filters-drawer(:class="{'is-open': drawerOpen}", v-if="data.length > count")
		.filters-drawerTrigger(
			tabindex="0",
			@keypress.enter="drawerOpen = !drawerOpen",
			@click="drawerOpen = !drawerOpen")
			span.filters-drawerTitle Additional Filters
			i.filters-drawerIcon.icon_adjust-horiz
		app-expand-transition
			.filters-drawerContent(v-if="drawerOpen")
				.filters-row
					.filters-column(v-for="(filter, i) in data" v-if="i >= count")
						app-select(v-if="filter.Type=='select'", :data="filter")
						app-range(v-if="filter.Type=='range'", :data="filter")
	app-meta(
		:data="data",
		@reset="reset()")
</template>


<script>
import { mapActions, mapGetters } from "vuex";
import Theme from "@/listing-app/mixins/Theme";
import ExpandTransition from "@/listing-app/components/ExpandTransition";
import Select from "./filters/Select";
import MultiSelect from "./filters/MultiSelect";
import Range from "./filters/Range";
import Meta from "./filters/Meta";

export default {
  name: "Filters",
  mixins: [Theme],
  props: ["terms", "data"],
  components: {
    appExpandTransition: ExpandTransition,
    appSelect: Select,
    appMultiSelect: MultiSelect,
    appRange: Range,
    appMeta: Meta
  },
  data() {
    return {
      drawerOpen: false
    };
  },
  computed: {
    ...mapGetters(["read"]),
    term() {
      return this.read("term");
    },
    count() {
      return this.terms.Type == "select" ? 2 : 3;
    }
  },
  methods: {
    ...mapActions(["set"]),
    reset() {
      this.set({muta: 'clear_filters', data: null})
      this.data.forEach(filter => {
        if (filter.Type == "select") {
          let defaultAvailable = false;
          filter.Values.forEach(option => {
            if (option.hasOwnProperty("Default") && option.Default == true) {
              this.set({
                muta: "filters",
                data: {
                  filter: filter.ID,
                  value: option.ID,
                  text: option.Text
                }
              });
              defaultAvailable = true;
            }
          });
          if (!defaultAvailable) {
            this.set({
              muta: "filters",
              data: {
                filter: filter.ID,
                value: filter.Values[0].ID,
                text: filter.Values[0].Text
              }
            });
          }
        } else if (filter.Type == "multiselect") {
          let defaultAvailable = false;
          let multi = filter.Values.reduce((_multi, option) => {
            if (option.hasOwnProperty("Default") && option.Default == true) {
              defaultAvailable = true;
              _multi.push({ value: option.ID, text: option.Text });
            }
            return _multi;
          }, []);

          if (defaultAvailable) {
            this.set({
              muta: "filters",
              data: {
                filter: filter.ID,
                multi
              }
            });
          } else {
            this.set({
              muta: "filters",
              data: {
                filter: filter.ID,
                multi: [
                  { value: filter.Values[0].ID, text: filter.Values[0].Text }
                ]
              }
            });
          }
        } else if (filter.Type == "range") {
          this.set({
            muta: "filters",
            data: {
              filter: filter.ID,
              value: filter.Values.Max
            }
          });
        }
      });
    }
  },
  watch: {
    term() {
      this.reset();
    }
  },
  mounted() {
    if (!this.read("initialLoad")) {
      this.reset();
    } else {
      this.set({ muta: "initialLoad", data: false });
    }
  }
};
</script>


<style lang="scss" scoped>
.filters {
  padding: 20px 0 0;
  position: relative;
}

.filters-row {
  display: flex;
  margin: 0 -1rem;
  flex-direction: column;
  @media (min-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
}

.filters-column {
  display: flex;
  flex-direction: column;
  margin: 0 1rem 1rem;
  &:last-child {
    margin-bottom: 0;
  }
  @media (min-width: 768px) {
    flex: 0 1 calc(33.33333% - 32px);
    max-width: calc(33.33333% - 32px);
    flex-direction: row;
    align-items: flex-start;
    margin: 0 1rem;
  }
}

.filters-drawer {
  border: 1px solid $gray;
  background: $white;
  padding: 0.125rem;
  transition: 0.25s ease;
  margin-top: 1rem;
  &:hover {
    border: 1px solid var(--color_primary);
  }
  &.is-open {
    padding-bottom: 10px;
  }
}
.filters-drawerTrigger {
  display: flex;
  align-items: center;
  padding: 0 10px;
  cursor: pointer;
  color: $black;
  height: 33px;
  .filters-drawerTitle {
    line-height: 1;
    white-space: nowrap;
    font-size: 1rem;
    text-transform: uppercase;
		color: $mediumGray;
		font-family: $fontFamilyHeadings;
  }
  .filters-drawerIcon {
    position: relative;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    justify-content: space-between;
    margin-left: auto;
    padding-left: 0.5rem;
		font-size: 1.5rem;
  }
}

.filters-drawerContent {
  padding: 0 10px;
  @media (min-width: 768px) {
    [class*="col"]:nth-child(n + 4) {
      margin-top: 10px;
    }
  }
}
</style>
